<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd" style="min-width: 60px;">
      <div class="fr">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加页面
        </router-link>
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="描述" prop="description"></el-table-column>
      <el-table-column label="类型" prop="type">
        <template scope="scope">
          {{scope.type | pageType}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-button type="text" @click="openConfigDialog(scope.row)">配置</el-button>&nbsp;|&nbsp;
          <router-link :to="{ name: 'pageEdit', params: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">编辑</router-link>
          <el-button type="default" size="small" @click="delPage(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <configuration ref="configuration" :configData="configData"></configuration>
  </div>
</template>
<script>
  import mobileConfig from 'config/mobileConfig'
  import configuration from './configuration.vue'
  import http from 'assets/js/http'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        configData: []
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        this.loading = true
        let res = await this.getData()
        this.tableData = res
        this.loading = false
      },
      openConfigDialog(item) {
        this.checkOperationData(item.id)
        this.$refs.configuration.dialogShow = true
      },
      delPage(item, index) {
        this.$confirm('确认删除该页面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('mobile/page/del/', item.id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              setTimeout(() => {
                this.tableData.splice(index, 1)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
        })
      },
      checkOperationData(id) {
        this.apiGet(`mobile/page/components/${id}`).then((res) => {
          let result = this.promiseHandler({}, res)
          this.configData = result
        })
      },
      /**
       * 获取页面列表
       */
      async getData() {
        let obj = {}
        let res = await this.apiGet('mobile/page/index', {})
        return this.promiseHandler(obj, res)
      }
    },
    components: {
      configuration
    },
    mixins: [http, mobileConfig]
  }
</script>


// WEBPACK FOOTER //
// list.vue?20fb0f3a